import { useState, useCallback, useEffect } from 'react';
import { getAllSnapshots } from 'src/shared/services/memberSnapshotTimeService';
import { DateHelper } from 'src/shared/helpers/dateHelper';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { SnapshotTimeResponse } from '../models/snapshotTimeResponse';

export const useFetchSnapshots = () => {
  const [spans, setSpans] = useState<SnapshotTimeResponse[]>([]);
  const [isSnapshotLoading, setIsSnapshotLoading] = useState<boolean>(false);
  const isMounted = useIsMounted();

  const fetchSnapshot = useCallback(async () => {
    setIsSnapshotLoading(true);
    try {
      const res = await getAllSnapshots({
        filter: '',
        pageIndex: 0,
        pageSize: 100,
        sortCol: '',
        sortDir: undefined,
      });
      if (isMounted()) {
        const todaySnapshot: SnapshotTimeResponse = {
          snapshotTime_id: 0,
          snapshotTime: DateHelper.getDate(new Date()),
          type: 0,
          comment: '',
        };

        const updatedSpans = [todaySnapshot, ...res.data.results];
        setSpans(updatedSpans);
      }
    } catch (error) {
      if (isMounted()) {
        ConsoleHelper.log('Error', error);
      }
    } finally {
      if (isMounted()) {
        setIsSnapshotLoading(false);
      }
    }
  }, [isMounted]);

  useEffect(() => {
    fetchSnapshot();
  }, [fetchSnapshot]);

  return { spans, isSnapshotLoading, fetchSnapshot };
};
